import { render, staticRenderFns } from "./tax-loss-harvest.vue?vue&type=template&id=3229142d&"
import script from "./tax-loss-harvest.vue?vue&type=script&lang=js&"
export * from "./tax-loss-harvest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports